import axios from "../utils/http";
import path from "./path"
const VERSION = 20240617;
const stringFormat = (formatted, args) => {
  for (let i = 0; i < args.length; i++) {
    let regexp = new RegExp('\\{' + i + '\\}', 'gi')
    formatted = formatted.replace(regexp, args[i])
  }
  return formatted
}
const api = {
  getOssKeySecret() {
    return axios.get(path.baseUrl + path.getOssKeySecret)
  },
  getQueryForm(formId, query) {
    return axios.get(path.baseUrl + path.queryForm[formId], { params: query })
  },
  get(url, query) {
    if (query) {
      return axios.get(path.baseUrl + url, { params: query })
    }
    return axios.get(path.baseUrl + url)
  },
  post(url, data) {
    return axios.post(path.baseUrl + url, data)
  },
  getDialogForm(dataId, bindId) {
    if (bindId != null) {
      return axios.get(path.baseUrl + stringFormat(path.dialogs[dataId], [bindId]))
    }
    return axios.get(path.baseUrl + path.dialogs[dataId])
  },
  getMenus() {
    return axios.get(path.baseUrl + path.menus)
  },
  getUserInfo() {
    return axios.get(path.baseUrl + path.userInfo)
  },
  getLoginCaptchaToken() {
    return axios.get(path.baseUrl + path.loginCaptchaToken)
  },
  login(data) {
    return axios.post(path.baseUrl + path.login, data)
  },
  logout() {
    return axios.get(path.baseUrl + path.logout)
  },
  updateSystemConfig(data) {
    return axios.post(path.baseUrl + path.updateSystemConfig, data);
  },
  getSystemConfig() {
    return axios.get(path.baseUrl + path.getSystemConfig)
  },
  updateImageValue(data) {
    return axios.post(path.baseUrl + path.updateImageValue, data);
  },
  getEnumOptionList(enumIndex) {
    return axios.get(path.baseUrl + stringFormat(path.getEnumOptionList, [enumIndex]))
  },
  startPractice(subject) {
    return axios.get(path.baseUrl + stringFormat(path.startPractice, [subject]))
  },
  acknowledgeCircuitRoutingIntroduction(examId) {
    return axios.post(path.baseUrl + path.acknowledgeCircuitRoutingIntroduction, {examId})
  },
  beginReaction(examId) {
    return axios.post(path.baseUrl + stringFormat(path.beginReaction, [examId]), {})
  },
  submitReactionAnswers(examId, body) {
    return axios.post(path.baseUrl + stringFormat(path.submitReactionAnswers, [examId]), body)
  },
  finishReaction(examId, body) {
    return axios.post(path.baseUrl + stringFormat(path.finishReaction, [examId]), body)
  },
  queryCurrentQuestion(examId) {
    return axios.get(path.baseUrl + stringFormat(path.queryCurrentQuestion, [examId]))
  },
  submitAnswer(query) {
    query.version = VERSION;
    return axios.get(path.baseUrl + path.submitAnswer, { params: query })
  },
  queryHistoryExamResult(examId) {
    return axios.get(path.baseUrl + stringFormat(path.queryHistoryExamResult, [examId]))
  },
  batchSubmitAnswer(body) {
    body.version = VERSION;
    return axios.post(path.baseUrl + path.batchSubmitAnswer, body);
  },
  getUserGroupList() {
    return axios.get(path.baseUrl + path.getUserGroupList)
  },
  deleteUser(userId) {
    return axios.get(path.baseUrl + stringFormat(path.deleteUser, [userId]))
  },
  deleteGroup(groupId,keepUser) {
    return axios.get(path.baseUrl + stringFormat(path.deleteGroup, [groupId,keepUser]))
  },
  getLogicalGroups() {
    return axios.get(path.baseUrl + path.getLogicalGroups)
  },
  getLogical2dGroups() {
    return axios.get(path.baseUrl + path.getLogical2dGroups)
  },
  getTextLogicalGroups() {
    return axios.get(path.baseUrl + path.getTextLogicalGroups)
  },
  getOpticalPathGroups() {
    return axios.get(path.baseUrl + path.getOpticalPathGroups)
  },
  getLogicalQuestionByGroupId(groupId) {
    return axios.get(path.baseUrl + stringFormat(path.getLogicalQuestionByGroupId, [groupId]))
  },
  getLogical2dQuestionByGroupId(groupId) {
    return axios.get(path.baseUrl + stringFormat(path.getLogical2dQuestionByGroupId, [groupId]))
  },
  getTextLogicalQuestionByGroupId(groupId, publishedOnly = false) {
    if (publishedOnly) {
      return axios.get(path.baseUrl + path.getTextLogicalQuestions, {
        params: {groupId, publishStatus: 'PUBLISHED', page: 0, pageSize: 500}
      })
    }
    return axios.get(path.baseUrl + stringFormat(path.getTextLogicalQuestionByGroupId, [groupId]))
  },
  getTextLogicalQuestions(params) {
    return axios.get(path.baseUrl + path.getTextLogicalQuestions, {params})
  },
  getOpticalPathQuestions(params) {
    return axios.get(path.baseUrl + path.getOpticalPathQuestions, {params})
  },
  deleteOpticalPathQuestion(id) {
    return axios.get(path.baseUrl + stringFormat(path.deleteOpticalPathQuestion, [id]))
  },
  deleteOpticalPathGroup(groupId) {
    return axios.get(path.baseUrl + stringFormat(path.deleteOpticalPathGroup, [groupId]))
  },
  toggleOpticalPathQuestion(data) {
    return axios.post(path.baseUrl + path.toggleOpticalPathQuestion, data)
  },
  saveOpticalPathQuestion(data) {
    return axios.post(path.baseUrl + '/manager/optical-path/save', data)
  },
  getTextAnalogyDetail(id) {
    return axios.get(path.baseUrl + path.getTextAnalogyDetail, {params: {id}})
  },
  saveTextAnalogyDraft(data) {
    return axios.post(path.baseUrl + path.saveTextAnalogyDraft, data)
  },
  publishTextAnalogy(id) {
    return axios.post(path.baseUrl + path.publishTextAnalogy, {id})
  },
  copyTextAnalogyAsDraft(id) {
    return axios.post(path.baseUrl + path.copyTextAnalogyAsDraft, {id})
  },
  archiveTextAnalogy(id) {
    return axios.post(path.baseUrl + path.archiveTextAnalogy, {id})
  },
  getUnfolding3DQuestionByGroupId(groupId) {
    return axios.get(path.baseUrl + stringFormat(path.getUnfolding3DQuestionByGroupId, [groupId]))
  },
  getLogicalQuestionTypeMap() {
    return axios.get(path.baseUrl + path.getLogicalQuestionTypeMap)
  },
  deleteLogicalQuestion(qid) {
    return axios.get(path.baseUrl + stringFormat(path.deleteLogicalQuestion, [qid]))
  },
  deleteLogical2dQuestion(qid) {
    return axios.get(path.baseUrl + stringFormat(path.deleteLogical2dQuestion, [qid]))
  },
  deleteTextLogicalQuestion(qid) {
    return axios.get(path.baseUrl + stringFormat(path.deleteTextLogicalQuestion, [qid]))
  },
  deleteUnfolding3dQuestion(qid) {
    return axios.get(path.baseUrl + stringFormat(path.deleteUnfolding3dQuestion, [qid]))
  },
  deleteLogicalGroup(groupId) {
    return axios.get(path.baseUrl + stringFormat(path.deleteLogicalGroup, [groupId]))
  },
  deleteLogical2dGroup(groupId) {
    return axios.get(path.baseUrl + stringFormat(path.deleteLogical2dGroup, [groupId]))
  },
  deleteTextLogicalGroup(groupId) {
    return axios.get(path.baseUrl + stringFormat(path.deleteTextLogicalGroup, [groupId]))
  },
  deleteUnfolding3dGroup(groupId) {
    return axios.get(path.baseUrl + stringFormat(path.deleteUnfolding3dGroup, [groupId]))
  },
  getQuestionTplGroupList() {
    return axios.get(path.baseUrl + path.getQuestionTplGroupList)
  },
  getUnfolding3DQuestionGroups() {
    return axios.get(path.baseUrl + path.getUnfolding3DQuestionGroups)
  },
  deleteTplGroup(groupId) {
    return axios.get(path.baseUrl + stringFormat(path.deleteTplGroup, [groupId]))
  },
  getQuestionTplInfo(tplId) {
    return axios.get(path.baseUrl + stringFormat(path.getQuestionTplInfo, [tplId]))
  },
  previewTplQuestion(tplId) {
    return axios.get(path.baseUrl + stringFormat(path.previewTplQuestion, [tplId]))
  },
  reGenerateQuestionTpl(query) {
    return axios.get(path.baseUrl + path.reGenerateQuestionTpl, { params: query })
  },
  updateTplQuestionId(query) {
    return axios.get(path.baseUrl + path.updateTplQuestionId, { params: query })
  },
  getTeachPlanInfo(planId) {
    return axios.get(path.baseUrl + stringFormat(path.getTeachPlanInfo, [planId]))
  },
  addTpl2ClassPlan(query) {
    return axios.get(path.baseUrl + path.addTpl2ClassPlan, { params: query })
  },
  deleteTplFromPlan(query) {
    return axios.get(path.baseUrl + path.deleteTplFromPlan, { params: query })
  },
  getClassRoomInfo(roomId) {
    return axios.get(path.baseUrl + stringFormat(path.getClassRoomInfo, [roomId]))
  },
  enableClassTpl(query) {
    return axios.get(path.baseUrl + path.enableClassTpl, { params: query })
  },
  queryClassRoom() {
    return axios.get(path.baseUrl + path.queryClassRoom)
  },
  getActiveTplList(roomId) {
    return axios.get(path.baseUrl + stringFormat(path.getActiveTplList, [roomId]))
  },
  startTplWork(query) {
    return axios.get(path.baseUrl + path.startTplWork, { params: query })
  },
  startTplWorkById(workId) {
    return axios.get(path.baseUrl + stringFormat(path.startTplWorkById, [workId]))
  },
  updateTplRuntimeParams(data) {
    return axios.post(path.baseUrl + path.updateTplRuntimeParams, data);
  },
  getMechanicalArmPoseScenario(tplId, questionIndex) {
    return axios.get(path.baseUrl + path.getMechanicalArmPoseScenario, { params: { tplId, questionIndex } });
  },
  saveMechanicalArmPoseScenario(data) {
    return axios.post(path.baseUrl + path.saveMechanicalArmPoseScenario, data);
  },
  publishMechanicalArmPose(tplId) {
    return axios.post(path.baseUrl + path.publishMechanicalArmPose, { tplId });
  },
  getClassAnswerStatistic(query) {
    return axios.get(path.baseUrl + path.getClassAnswerStatistic, { params: query })
  },
  getSeesawGroups() {
    return axios.get(path.baseUrl + path.getSeesawGroups)
  },
  getSeesawByGroupId(groupId) {
    return axios.get(path.baseUrl + stringFormat(path.getSeesawByGroupId, [groupId]))
  },
  deleteSeesawQuestion(qid) {
    return axios.get(path.baseUrl + stringFormat(path.deleteSeesawQuestion, [qid]))
  },
  deleteSeesawGroup(gid) {
    return axios.get(path.baseUrl + stringFormat(path.deleteSeesawGroup, [gid]))
  },
  getPriceCalculateGroups() {
    return axios.get(path.baseUrl + path.getPriceCalculateGroups)
  },
  getPriceCalculateByGroupId(groupId) {
    return axios.get(path.baseUrl + stringFormat(path.getPriceCalculateByGroupId, [groupId]))
  },
  deletePriceCalculateQuestion(qid) {
    return axios.get(path.baseUrl + stringFormat(path.deletePriceCalculateQuestion, [qid]))
  },
  deletePriceCalculateGroup(gid) {
    return axios.get(path.baseUrl + stringFormat(path.deletePriceCalculateGroup, [gid]))
  },
  getUserMenu() {
    return axios.get(path.baseUrl + path.getUserMenu)
  },
  getDifficultySettings() {
    return axios.get(path.baseUrl + path.getDifficultySettings)
  },
  updateSubjectSetting(data) {
    return axios.post(path.baseUrl + path.updateSubjectSetting, data);
  },
  updateSystemSetting(data) {
    return axios.post(path.baseUrl + path.updateSystemSetting, data);
  },
  markTplGroupAsHistory(groupId) {
    return axios.get(path.baseUrl + stringFormat(path.markTplGroupAsHistory, [groupId]))
  },
  updateRandomPractice(tplId) {
    return axios.get(path.baseUrl + stringFormat(path.updateRandomPractice, [tplId]))
  },
  getServerTime() {
    return axios.get(path.baseUrl + path.getServerTime)
  },
  getUserExamAverageAndRank(params) {
    return axios.get(path.baseUrl + path.getUserExamAverageAndRank, { params })
  },
  getUserExamstatistic(params) {
    return axios.get(path.baseUrl + path.getUserExamstatistic, { params })
  },
  getClassAnswerData(params) {
    return axios.get(path.baseUrl + path.getClassAnswerData, { params })
  },
  // 管理段模拟考试
    // 计划
  getMockExamPlanList() {
    return axios.get(path.baseUrl + path.getMockExamPlanList, { params: {page: 0, pageSize: 100} })
  },
  createMockExamPlan(params) {
    return axios.post(path.baseUrl + path.createMockExamPlan, params)
  },
  deleteMockExamPlan(params) {
    return axios.delete(path.baseUrl + path.deleteMockExamPlan,  { params }) 
  },
  updateMockExamPlan(params) {
    return axios.put(path.baseUrl + path.updateMockExamPlan, params)
  },
  // 试卷
  createPaper(params) {
    return axios.post(path.baseUrl + path.createPaper, params)
  },
  updatePaper(params) {
    return axios.put(path.baseUrl + path.updatePaper, params)
  },
  getPaperList(params) {
    return axios.get(path.baseUrl + path.getPaperList, {params})
  },
  getPaperDetail(id) {
    return axios.get(path.baseUrl + path.getPaperDetail, )
  },
  deletePaper(params) {
    return axios.delete(path.baseUrl + path.deletePaper,  { params })
  },
  copyExamPlan(params) {
    return axios.post(path.baseUrl + path.copyExamPlan, params)
  },
  // 单元
  addExamUnit(params) {
    return axios.post(path.baseUrl + path.addExamUnit, params)
  },
  // 用户端考试接口
  getUserExamList() {
    return axios.get(path.baseUrl + path.getUserExamList)
  },
  getmockExamDetail(params) {
    return axios.get(path.baseUrl + path.getmockExamDetail, { params })
  },
  userStartMock(params) {
    return axios.post(path.baseUrl + path.userStartMock, params)
  },
  getCurrentQuestion(params) {
    return axios.get(path.baseUrl + path.getCurrentQuestion, { params })
  },
  submitUnitAnswerV2(params) {
    return axios.post(path.baseUrl + path.submitUnitAnswerV2, params)
  },
  batchSubmitUnitAnswerV2(params) {
    return axios.post(path.baseUrl + path.batchSubmitUnitAnswerV2, params)
  },
  beginMockReaction(params) {
    return axios.post(path.baseUrl + path.beginMockReaction, params)
  },
  submitMockReactionAnswers(params) {
    return axios.post(path.baseUrl + path.submitMockReactionAnswers, params)
  },
  finishMockReaction(params) {
    return axios.post(path.baseUrl + path.finishMockReaction, params)
  },
  getMockExamResult(params) {
    return axios.get(path.baseUrl + path.getMockExamResult, { params })
  },
  getExamRank(params) {
    return axios.get(path.baseUrl + path.getExamRank, { params })
  },
  
  // 立体纽结
  getKnotGroups(params) {
    return axios.get(path.baseUrl + path.getKnotGroups, { params })
  },
  deleteKnotGroup(groupId) {
    return axios.get(path.baseUrl + stringFormat(path.deleteKnotGroup, [groupId]))
  },
  deleteKnotQuestion(qid) {
    return axios.get(path.baseUrl + stringFormat(path.deleteKnotQuestion, [qid]))
  },
  getKnotQuestionByGroupId(groupId) {
    return axios.get(path.baseUrl + stringFormat(path.getKnotQuestionByGroupId, [groupId]))
  },
}

export default api;
